/*
 * Copyright (c) 2020. American Express Company
 */

// theirs
import { ChronoUnit, LocalDate } from '@js-joda/core';
import { CashFlowModel } from 'src/types/cash-flow.model';
import DateUtils from 'src/utils/date';
// ours
import { TimePeriod } from 'src/types/time-period';

export default class TimeService {
    public static getQuartersFromDate(startDate: LocalDate, endDate: LocalDate): number {
        if (!startDate || !endDate) return 0;
        return DateUtils.quartersUntil(startDate, endDate);
    }

    public static getSessionStartDate(cashFlows: CashFlowModel[]): LocalDate {
        return cashFlows[0].startDate;
    }

    public static getYearsOld(dob: LocalDate): number {
        if (!dob) return 0;
        return dob.until(LocalDate.now(), ChronoUnit.YEARS);
    }

    public static getLocalDateAtAge(dob: LocalDate, targetAge: number): LocalDate {
        if (!dob) return LocalDate.now();
        const currentAge = this.getYearsOld(dob);
        const yearsToTarget = targetAge - currentAge;
        return LocalDate.now().plusYears(yearsToTarget);
    }

    public static minDate(date1: LocalDate, date2: LocalDate): LocalDate {
        return LocalDate.ofEpochDay(Math.min(date1.toEpochDay(), date2.toEpochDay()));
    }

    public static maxDate(date1: LocalDate, date2: LocalDate): LocalDate {
        return LocalDate.ofEpochDay(Math.max(date1.toEpochDay(), date2.toEpochDay()));
    }

    public static getTimePeriodForRange(
        startDate: LocalDate,
        endDate: LocalDate,
        now: LocalDate = LocalDate.now()
    ): TimePeriod {
        let period: TimePeriod;
        switch (true) {
            case startDate.isAfter(now):
                period = TimePeriod.FUTURE;
                break;
            case startDate.isBefore(now) && endDate.isAfter(now):
                period = TimePeriod.PRESENT;
                break;
            case startDate.equals(now):
                period = TimePeriod.PRESENT;
                break;
            case endDate.isBefore(now):
                period = TimePeriod.PAST;
                break;
            case endDate.equals(now):
                period = TimePeriod.PAST;
                break;
        }

        return period;
    }
}
